import api from './api'

export type MediaPhotoSource = 'Google Places' | 'Street View' | 'Property website'

export type PropertyMediaPhoto = {
  token: string
  source: MediaPhotoSource
  alt: string
  attribution?: string
}

export type PropertyMediaLookup = {
  configured: boolean
  addressUsed: string
  formattedAddress: string | null
  lat: number | null
  lng: number | null
  photos: PropertyMediaPhoto[]
  notes: string[]
  website: string | null
  websiteSkipped: boolean
}

export const propertyMediaService = {
  lookup: (params: { address: string; website?: string | null }) =>
    api
      .get('/property-media', {
        params: {
          address: params.address,
          website: params.website || undefined,
        },
      })
      .then((r) => r.data as PropertyMediaLookup),

  photoUrl: (token: string) => {
    const base = (api.defaults.baseURL || '/api/v1').replace(/\/$/, '')
    return `${base}/property-media/photo?t=${encodeURIComponent(token)}`
  },
}
